import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const ChallengeInverseIcon: LucideIcon = forwardRef(({ size = 24, color = 'white', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M3.93069 17.9467C2.6309 16.266 1.92 14.2317 1.92 12.1359C1.92 6.76578 6.44008 2.39999 12 2.39999C17.5599 2.39999 22.08 6.76578 22.08 12.1359C22.08 14.2317 21.3691 16.266 20.0693 17.9467L17.3583 13.6783C17.0612 13.2068 16.6686 13.1351 16.4617 13.1351C16.2548 13.1351 15.8675 13.2068 15.5651 13.6731L13.9099 16.2762C12.7533 14.4623 11.6021 12.6432 10.4509 10.8292C10.4509 10.3424 10.4509 9.86077 10.4509 9.36372H14.7216C14.9444 9.3586 15.4219 9.34323 15.7031 8.8923C16.0108 8.39526 15.7296 7.94946 15.6394 7.80598C15.6394 7.80598 15.0293 6.83239 14.9073 6.6428C15.0505 6.41733 15.6712 5.43349 15.6712 5.43349C15.9577 4.98257 15.8463 4.61363 15.7031 4.38817C15.5704 4.17295 15.2999 3.92187 14.78 3.92187H9.59671C8.84337 3.92187 8.46139 4.29081 8.46139 5.02356V6.54031C8.46139 7.94946 8.46139 9.36372 8.46139 10.7729C8.46139 10.8139 8.45608 10.8344 8.43486 10.8651L3.93069 17.9467Z'
        fill={color}
      />
      <path
        d='M13.443 17.998C13.1299 17.5112 12.8222 17.0244 12.5092 16.5376C12.4827 16.5017 12.4562 16.4658 12.4243 16.4249C12.0158 16.7374 11.6179 17.05 11.2201 17.3523C10.9813 17.5368 10.8646 17.5368 10.6365 17.3523C10.281 17.0807 9.92026 16.8092 9.57011 16.5273C9.47462 16.4556 9.41626 16.4556 9.32607 16.5273C8.96001 16.8194 8.58864 17.1012 8.21727 17.3831C8.0475 17.5112 7.89896 17.5112 7.72919 17.3831C7.5382 17.2345 7.34721 17.0859 7.15622 16.9373C6.92809 16.763 6.69997 16.5888 6.46654 16.4044C5.36835 18.1363 4.27546 19.8478 3.17197 21.59C3.23563 21.59 3.27277 21.5951 3.3046 21.5951C5.92009 21.5951 8.54089 21.5951 11.1564 21.5951C11.2625 21.5951 11.3155 21.5541 11.3686 21.4773C12.0583 20.3858 12.748 19.2995 13.443 18.2132C13.5013 18.1261 13.4907 18.0646 13.443 17.9826V17.998Z'
        fill={color}
      />
      <path
        d='M12.0956 21.6H20.828C19.3638 19.2992 17.9208 17.0241 16.4618 14.7285C14.9976 17.0292 13.5545 19.3095 12.0956 21.6Z'
        fill={color}
      />
      <path
        d='M6.82737 15.846C7.21465 16.1483 7.59132 16.4353 7.97861 16.7376C8.38711 16.425 8.7797 16.1176 9.16699 15.8153C9.3792 15.6513 9.51713 15.6462 9.72404 15.8101C10.0848 16.0868 10.4456 16.3687 10.8063 16.6454C10.8647 16.6915 10.9124 16.753 11.0026 16.6812C11.3528 16.4045 11.7082 16.133 12.0743 15.8511C11.2042 14.4779 10.3341 13.1097 9.44817 11.7211C8.56219 13.1148 7.69743 14.4779 6.82737 15.8511V15.846Z'
        fill={color}
      />
      <path
        d='M14.2442 5.21828H9.80899V8.06731H14.2336C14.1964 8.0007 14.1699 7.95458 14.1381 7.90334C13.9312 7.57539 13.7402 7.24745 13.5174 6.92975C13.3794 6.72991 13.3794 6.56081 13.5174 6.35584C13.7667 5.99203 13.9895 5.60772 14.2336 5.21828H14.2442Z'
        fill={color}
      />
    </svg>
  )
})

ChallengeInverseIcon.displayName = 'ChallengeInverseIcon'
